"use strict";

var _regeneratorRuntime = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/sngr/develop/kitekure-site/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var gifuct_js_1 = __importDefault(require("./gifuct-js"));

var GIFData = /*#__PURE__*/function () {
  function GIFData(frames, width, height, pixelRatio) {
    _classCallCheck(this, GIFData);

    this.frames = [];
    this.index = 0;
    this.playTime = 0;
    this.frames = frames;
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.pixelRatio = pixelRatio;
    this.canvas.width = width;
    this.canvas.height = height;
    this.startTime = Date.now();
  }

  _createClass(GIFData, [{
    key: "getCanvas",
    value: function getCanvas() {
      return this.canvas;
    }
  }, {
    key: "update",
    value: function update() {
      var now = Date.now();
      var elapsedTime = now - this.startTime;

      while (this.playTime < elapsedTime) {
        var f = this.frames[this.index % this.frames.length];
        this.playTime += f.delay;
        this.index++;
      }

      var frame = this.frames[this.index % this.frames.length];
      var image = new ImageData(frame.patch, frame.dims.width, frame.dims.height);
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.ctx.putImageData(image, frame.dims.left, frame.dims.top);
    }
  }], [{
    key: "create",
    value: function create(src, pixelRatio) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var gif, frames, width, height;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(src).then(function (resp) {
                  return resp.arrayBuffer();
                }).then(function (buff) {
                  return new gifuct_js_1.default(buff);
                });

              case 2:
                gif = _context.sent;
                frames = gif.decompressFrames(true, undefined, undefined);
                width = gif.raw.lsd.width;
                height = gif.raw.lsd.height;
                return _context.abrupt("return", new GIFData(frames, width, height, pixelRatio));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return GIFData;
}();

exports.default = GIFData;